import { useEffect, useState } from 'react';
import FeatureApiClient from '../apiClient/FeatureApiClient';

/**
 * Hook that provides feature flag data for a provided org
 */
export const useFeatureFlags = (orgId: number) => {
  const [features, setFeatures] = useState(new Set<string>());
  const orgsApiClient = new FeatureApiClient();

  const asyncFeatures = async () => {
    // Clear out org features on org switch
    setFeatures(new Set());

    const orgFeatures = await orgsApiClient
      .getOrgFeatures({ org_id: orgId })
      //  @ts-ignore no types
      .then(res =>
        res.map((o: { feature_keycode: string }) => o.feature_keycode),
      );

    setFeatures(new Set(orgFeatures));
  };

  /**
   *
   * @param desiredFeature - name of feature flag to check for
   * @returns boolean indiciating whether features list has some flag
   */
  const isFeatureEnabled = (desiredFeature: string): boolean => {
    return features.has(desiredFeature);
  };

  useEffect(() => {
    asyncFeatures();
  }, [orgId]);

  return {
    features,
    isFeatureEnabled,
  };
};
